// DeepLinkHandler.js
import { useEffect } from 'react';

const APP_STORE_URL = 'https://apps.apple.com/us/app/hyphii-healthy-lifestyle-app/id6737209270';
const APP_SCHEME = 'hyphii://';
const WEB_URL = 'https://hyphii.me';

export const DeepLinkHandler = () => {
  useEffect(() => {
    const handleDeepLink = () => {
      // Get the current path and query parameters
      const currentPath = window.location.pathname;
      const queryParams = window.location.search;
      
      // Check if user is on iOS
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      
      if (isIOS) {
        // Create the deep link URL maintaining the exact path and query parameters
        const deepLink = `${APP_SCHEME}${currentPath.substring(1)}${queryParams}`;
        
        // Set up timeout for App Store redirect
        const timeoutId = setTimeout(() => {
          window.location.href = APP_STORE_URL;
        }, 2500); // 2.5 seconds timeout
        
        // Try to open the app
        window.location.href = deepLink;
        
        // Handle visibility change to clear timeout if app opens
        const handleVisibilityChange = () => {
          if (!document.hidden) {
            clearTimeout(timeoutId);
          }
        };
        
        document.addEventListener('visibilitychange', handleVisibilityChange);
        
        return () => {
          clearTimeout(timeoutId);
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
      } else {
        // Non-iOS devices redirect to App Store
        window.location.href = APP_STORE_URL;
      }
    };

    handleDeepLink();
  }, []);

  return null;
};

export default DeepLinkHandler;